import { useMemo } from 'react';
import useUser from './useUser';
import {
  SEGMENT_OTHERS,
  SEGMENT_POSTPAID,
  SEGMENT_PREPAID,
  SEGMENT_HYBRID,
} from '../shared/constants';

const useSegment = () => {
  const user = useUser();
  return useMemo(() => {
    const segment = user.plan.segment.toUpperCase();
    return {
      isHybrid: [SEGMENT_HYBRID].includes(segment),
      isOther: [SEGMENT_OTHERS].includes(segment),
      isPostpaid: [SEGMENT_POSTPAID].includes(segment),
      isPrepaid: [SEGMENT_PREPAID].includes(segment),
      segment,
    };
  }, [user]);
};

export default useSegment;
